module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkBAMAAAATLoWrAAAAAXNSR0IArs4c6QAAACdQTFRFVVVVgICAg4ODgICAhYWFh4eHhoaGiIiIiIiIh4eHh4eHiIiIh4eHG1W3ygAAAAx0Uk5TAwghJEuEhcfJyuL+8ZjNxwAAADdJREFUKM9jYBg8gFEBQ4h9K4YQx5kEdCHmNccwlFkNjDIHwkJYNGIaT1NFnJi+wRLQWKJjYAEArecavBt6rWcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/more-icon.png
// module id = Cy1P
// module chunks = 0